// Câmpurile implicite pentru formularul de candidat — folosite la adăugare
// (Candidati.vue) și la editare (CandidateDetails.vue). Factory comun ca să nu
// existe obiecte literale duplicate în două componente.
export const createEmptyCandidate = () => ({
  id: null,
  FirstName: "",
  LastName: "",
  PhoneNumber: "",
  Email: "",
  Country: "",
  Address: "",
  MarriageStatus: "",
  Children: "",
  AboutCandidate: "",
  Profession: "",
  Dateofbirth: "",
  Nationality: "",
  Specialization: "",
  LookingPosition: "",
  CVSource: "",
  CandidateContacted: false,
  InterestedInOffers: false,
  HasCV: false,
});
